import { NgModule } from '@angular/core';
import { TurnoverGraphComponent } from '@app/+authenticated/chart/components/turnover-graph/turnover-graph.component';
import { WorkedHoursGraphComponent } from '@app/+authenticated/chart/containers/worked-hours-graph/worked-hours-graph.component';
import { SharedModule } from '@shared/shared.module';

import { ContractRenewalsWidgetComponent } from './dashboard-widgets/contract-renewals-widget/contract-renewals-widget.component';
import { EndingContractsWidgetComponent } from './dashboard-widgets/ending-contracts-widget/ending-contracts-widget.component';
import { FilesToReviewWidgetComponent } from './dashboard-widgets/files-to-review-widget/files-to-review-widget.component';
import { MyExchangeWidgetComponent } from './dashboard-widgets/my-exchange-widget/my-exchange-widget.component';
import { MyNewsItemsWidgetComponent } from './dashboard-widgets/my-news-items-widget/my-news-items-widget.component';
import { MyOpenShiftWidgetComponent } from './dashboard-widgets/my-open-shift-widget/my-open-shift-widget.component';
import { MyScheduleWidgetComponent } from './dashboard-widgets/my-schedule-widget/my-schedule-widget.component';
import { MyTimesheetWidgetComponent } from './dashboard-widgets/my-timesheet-widget/my-timesheet-widget.component';
import { MyWeatherForecastWidgetComponent } from './dashboard-widgets/my-weather-forecast-widget/my-weather-forecast-widget.component';
import { NewHiresWidgetComponent } from './dashboard-widgets/new-hires-widget/new-hires-widget.component';
import { UpcomingBirthdaysWidgetComponent } from './dashboard-widgets/upcoming-birthdays-widget/upcoming-birthdays-widget.component';

const standalone = [
  MyScheduleWidgetComponent,
  MyTimesheetWidgetComponent,
  MyOpenShiftWidgetComponent,
  MyExchangeWidgetComponent,
  MyNewsItemsWidgetComponent,
  UpcomingBirthdaysWidgetComponent,
  EndingContractsWidgetComponent,
  TurnoverGraphComponent,
  WorkedHoursGraphComponent,
  MyWeatherForecastWidgetComponent,
  NewHiresWidgetComponent,
  ContractRenewalsWidgetComponent,
  FilesToReviewWidgetComponent,
];

@NgModule({
  imports: [SharedModule, ...standalone],
  exports: standalone,
})
export class MyDashboardModule {}
